import { useGetMultiSiteState } from 'App/actions/api/multisite';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { environmentLabelFooter } from 'config/envLables';
import { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import MultiSite from '../MultiSite';

const ORGANIZATION_LABEL_ID = 'footer-organization-label';

const Footer = ({ user, setActiveRole, activeRole }) => {
  const { data: multiSiteState } = useGetMultiSiteState();
  const multiSiteColor = useMemo(() => {
    if (multiSiteState?.mode === 'Multi') {
      return multiSiteState?.state === 'Active' ? 'success.main' : 'warning.main';
    }
    return undefined;
  }, [multiSiteState]);
  const handleOrganizationChange = useCallback(
    e => {
      const role = user?.roles?.find(item => item.organizationId === e.target.value);
      if (role) {
        setActiveRole(role);
      }
    },
    [user, setActiveRole]
  );
  return (
    <AppBar
      component="div"
      position="fixed"
      sx={{
        p: 0,
        borderTop: `${multiSiteColor ? '3px' : '1px'} solid`,
        borderColor: multiSiteColor || 'borders.moderate',
        top: 'auto',
        left: 0,
        bottom: 0,
        bgcolor: 'surface.7',
        zIndex: 2000,
      }}
    >
      <Box sx={{ height: 40, display: 'flex', alignItems: 'center', ml: 2 }}>
        <MultiSite multiSiteState={multiSiteState} />
        <Typography id={ORGANIZATION_LABEL_ID} sx={{ ml: 2, color: 'secondary.main' }}>
          <FormattedMessage id="sharedComponents-Footer-organization" defaultMessage="Organization:" />
        </Typography>
        {user?.roles &&
          (user.roles.length === 1 ? (
            <Typography sx={{ ml: 1, color: 'text.primary', textTransform: 'uppercase', fontSize: '14px' }}>
              {activeRole?.organizationDetails?.name}
            </Typography>
          ) : (
            <FormControl size="small" variant="outlined" sx={{ ml: 1, minWidth: 160 }}>
              <Select
                labelId={ORGANIZATION_LABEL_ID}
                value={activeRole?.organizationId ?? ''}
                onChange={handleOrganizationChange}
                sx={{ height: 30, fontSize: '14px', textTransform: 'uppercase' }}
                MenuProps={{
                  anchorOrigin: { vertical: 'top', horizontal: 'left' },
                  transformOrigin: { vertical: 'bottom', horizontal: 'left' },
                  // Footer AppBar sits at zIndex 2000, above the default modal layer.
                  sx: { zIndex: 2100 },
                }}
              >
                {user.roles.map(item =>
                  item.organizationDetails ? (
                    <MenuItem key={item.organizationId} value={item.organizationId}>
                      {item.organizationDetails.name}
                    </MenuItem>
                  ) : null
                )}
              </Select>
            </FormControl>
          ))}
        {environmentLabelFooter && (
          <>
            <Typography sx={{ ml: 2, color: 'secondary.main' }}>
              <FormattedMessage id="sharedComponents-Footer-environment" defaultMessage="Environment:" />
            </Typography>
            <Typography sx={{ ml: 1, color: 'text.primary', textTransform: 'uppercase', fontSize: '14px' }}>
              {environmentLabelFooter}
            </Typography>
          </>
        )}
        <Box sx={{ flexGrow: 1 }} />
      </Box>
    </AppBar>
  );
};

export default Footer;
